import { render, staticRenderFns } from "./ActivityJoin.vue?vue&type=template&id=38364596&scoped=true&"
import script from "./ActivityJoin.vue?vue&type=script&lang=js&"
export * from "./ActivityJoin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38364596",
  null
  
)

export default component.exports